"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var clone = require('clone');
var tv4 = require('tv4');
var SEVERITY = require('../../constant/reminder/severity.constant');
var Todo = /*#__PURE__*/function () {
  function Todo(opt) {
    _classCallCheck(this, Todo);
    this.title = null;
    this.description = null;
    this.severity = null;
    this.link = null;
    this.sendDate = null;
    if (opt && opt.details) {
      this.fillObject(clone(opt.details));
    }
  }
  _createClass(Todo, [{
    key: "fillObject",
    value: function fillObject(details) {
      this.title = details.title;
      this.description = details.description || null;
      this.severity = details.severity || SEVERITY.LOW;
      this.link = details.link;
      this.sendDate = details.sendDate ? new Date(details.sendDate) : null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Todo.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'todo.schema.json',
        type: 'object',
        properties: {
          title: {
            type: 'string'
          },
          description: {
            type: ['string', 'null']
          },
          severity: {
            "enum": Object.keys(SEVERITY)
          },
          link: {
            type: 'string'
          },
          sendDate: {
            type: ['object', 'null']
          }
        },
        required: ['title', 'link', 'description', 'severity']
      };
    }
  }]);
  return Todo;
}();
module.exports = Todo;